import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { canWorkspaceBeEmpty } from 'state/workspaces/model';
import { applyPersistedWorkspaceTabsThunk } from 'state/workspaces/workspace.thunks';

export function applyOrCreateTabOnPostTradeTabsFetchedEpic(): SpEpic {
  return actions$ =>
    actions$.pipe(
      ofType('WORKSPACE_TABS_FETCHED'),
      filter(action => canWorkspaceBeEmpty(action.workspace)),
      map(({ tabs, activeTabId, workspace }) => applyPersistedWorkspaceTabsThunk(tabs, activeTabId, workspace)),
    );
}
